import React from 'react';
import TapNativeAdUnit from './TapNativeAdUnit';

const GLP1_BRIDGE_COMPACT_TAPNATIVE_UNITS = ['111820', '111819'];

export default function Glp1BridgeCompactTapNativeAds({ placement }) {
  return (
    <div
      className="mx-auto max-w-[20px]"
      data-testid="glp1-bridge-compact-tapnative-ads"
      data-placement={placement}
    >
      {GLP1_BRIDGE_COMPACT_TAPNATIVE_UNITS.map((adUnitId) => (
        <TapNativeAdUnit
          key={adUnitId}
          adUnitId={adUnitId}
          captureIdentity
          label={null}
          minHeightClass="min-h-[20px] max-h-[20px] overflow-hidden"
          placement={placement}
          variant="compact"
        />
      ))}
    </div>
  );
}
